import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateGcOUSettingForm } from '../../../../actions/organisation';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const showDefaultGroupConsultationSettings = ({
  orgUnit,
  updateOrView,
  showOuDefaultGcSettingsModal,
  isAdmin,
  isGCSettingsEnabled,
}) => {
  const dispatch = useDispatch();
  let title = APP.LANGUAGE.GCSettings.TitleUpdateAndView;
  let orgName = orgUnit.name;
  var updatingOrgName = orgUnit ? orgUnit.name : '';
  let subtitle = updatingOrgName;

  const ouGcWaitingAreaSettings = useSelector((state) => state.organisationsReducer.ouGcSettings);
  const [validateForm, setValidateForm] = useState();
  const [saveButtonDisableClass, setSaveButtonDisableClass] = useState('disable');

  useEffect(() => {
    dispatch(
      updateGcOUSettingForm({
        isChatEnabled: ouGcWaitingAreaSettings?.isChatEnabled,
        isCallerFullNameEnabled: ouGcWaitingAreaSettings?.isCallerFullNameEnabled,
      })
    );
    setValidateForm({
      isChatEnabled: ouGcWaitingAreaSettings?.isChatEnabled,
      isCallerFullNameEnabled: ouGcWaitingAreaSettings?.isCallerFullNameEnabled,
    });
  }, []);

  let rightPanel = (
    <RightPanelTop
      orgUnit={orgUnit}
      setSaveButtonDisableClass={setSaveButtonDisableClass}
      saveButtonDisableClass={saveButtonDisableClass}
      validateForm={validateForm}
    />
  );

  let centerPanel = <CenterPanelUpdate isAdmin={isAdmin} setSaveButtonDisableClass={setSaveButtonDisableClass} />;

  return (
    <Modal show={showOuDefaultGcSettingsModal} hideWhenClickAway={false} className={'waiting-area-after-call'}>
      <PopupHeader title={title} subtitle={subtitle} helpLink={window.APP.EXTERNAL_LINKS.GCSetting.GCSettingDialog} />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default showDefaultGroupConsultationSettings;
